define.alias("shared/components/shared/card/footer", "calendar/components/shared/card/footer");